import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ComputeJob } from './types';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface ComputeJobsState {
  jobs: ComputeJob[];
  loading: boolean;
  error: string | null;
  filterMaximised: boolean;
  selectedJobId: string | null;
}

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: ComputeJobsState = {
  jobs: [],
  loading: false,
  error: null,
  filterMaximised: true,
  selectedJobId: null,
};

//	--------------------------------------------------------------------------
//
//	S L I C E
//
//	--------------------------------------------------------------------------

export const computeJobsSlice = createSlice({
  name: 'computeJobs',
  initialState: initialState,
  reducers: {
    setJobs: (state: ComputeJobsState, action: PayloadAction<ComputeJob[]>) => {
      state.jobs = action.payload;
      state.loading = false;
      state.error = null;
    },

    addJob: (state: ComputeJobsState, action: PayloadAction<ComputeJob>) => {
      // Add new job to the beginning of the list
      state.jobs.unshift(action.payload);
    },

    updateJob: (state: ComputeJobsState, action: PayloadAction<ComputeJob>) => {
      const index = state.jobs.findIndex((job) => job.job_id === action.payload.job_id);
      if (index !== -1) {
        state.jobs[index] = action.payload;
      }
    },

    removeJob: (state: ComputeJobsState, action: PayloadAction<string>) => {
      state.jobs = state.jobs.filter((job) => job.job_id !== action.payload);
    },

    setLoading: (state: ComputeJobsState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setError: (state: ComputeJobsState, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },

    setFilterMaximised: (state: ComputeJobsState, action: PayloadAction<boolean>) => {
      state.filterMaximised = action.payload;
    },

    setSelectedJobId: (state: ComputeJobsState, action: PayloadAction<string | null>) => {
      state.selectedJobId = action.payload;
    },

    clearJobs: (state: ComputeJobsState) => {
      state.jobs = [];
      state.error = null;
      state.selectedJobId = null;
    },
  },
});

//	--------------------------------------------------------------------------
//
//	E X P O R T S
//
//	--------------------------------------------------------------------------

export const {
  setJobs,
  addJob,
  updateJob,
  removeJob,
  setLoading,
  setError,
  setFilterMaximised,
  setSelectedJobId,
  clearJobs,
} = computeJobsSlice.actions;

export default computeJobsSlice.reducer;
